// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SocialAuthConfQueryVariables = Types.Exact<{
  site: Types.Scalars['String']['input'];
}>;


export type SocialAuthConfQuery = { __typename?: 'Query', userManagement?: { __typename?: 'UserManagement', id: string, auth0Conf?: { __typename?: 'UserManagementAuth0Conf', id: string, clientId?: string, domain?: string, connections?: Array<{ __typename?: 'UserManagementAuth0Connection', handle?: string, title?: string }> }, cognitoConf?: { __typename?: 'UserManagementCognitoConf', id: string, clientId?: string, domain?: string, connections?: Array<{ __typename?: 'UserManagementCognitoConnection', handle?: string, title?: string }> } } };

export type Auth0ConfigFragment = { __typename?: 'UserManagementAuth0Conf', id: string, clientId?: string, domain?: string, connections?: Array<{ __typename?: 'UserManagementAuth0Connection', handle?: string, title?: string }> };

export type CognitoConfigFragment = { __typename?: 'UserManagementCognitoConf', id: string, clientId?: string, domain?: string, connections?: Array<{ __typename?: 'UserManagementCognitoConnection', handle?: string, title?: string }> };

export const Auth0ConfigFragmentDoc = /*#__PURE__*/ gql`
    fragment Auth0ConfigFragment on UserManagementAuth0Conf {
  id
  clientId
  domain
  connections {
    handle
    title
  }
}
    `;
export const CognitoConfigFragmentDoc = /*#__PURE__*/ gql`
    fragment CognitoConfigFragment on UserManagementCognitoConf {
  id
  clientId
  domain
  connections {
    handle
    title
  }
}
    `;
export const SocialAuthConfQueryDocument = /*#__PURE__*/ gql`
    query SocialAuthConfQuery($site: String!) {
  userManagement {
    id
    auth0Conf(site: $site) {
      ...Auth0ConfigFragment
    }
    cognitoConf(site: $site) {
      ...CognitoConfigFragment
    }
  }
}
    ${Auth0ConfigFragmentDoc}
${CognitoConfigFragmentDoc}`;
export function useSocialAuthConfQuery(baseOptions: Apollo.QueryHookOptions<SocialAuthConfQuery, SocialAuthConfQueryVariables> & ({ variables: SocialAuthConfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialAuthConfQuery, SocialAuthConfQueryVariables>(SocialAuthConfQueryDocument, options);
      }
export function useSocialAuthConfQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialAuthConfQuery, SocialAuthConfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialAuthConfQuery, SocialAuthConfQueryVariables>(SocialAuthConfQueryDocument, options);
        }
export function useSocialAuthConfQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SocialAuthConfQuery, SocialAuthConfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SocialAuthConfQuery, SocialAuthConfQueryVariables>(SocialAuthConfQueryDocument, options);
        }
export type SocialAuthConfQueryHookResult = ReturnType<typeof useSocialAuthConfQuery>;
export type SocialAuthConfQueryLazyQueryHookResult = ReturnType<typeof useSocialAuthConfQueryLazyQuery>;
export type SocialAuthConfQuerySuspenseQueryHookResult = ReturnType<typeof useSocialAuthConfQuerySuspenseQuery>;
export type SocialAuthConfQueryQueryResult = Apollo.QueryResult<SocialAuthConfQuery, SocialAuthConfQueryVariables>;